import type { ShippingTransportationGroupsListResponse } from './api';

export const normalizeShippingTransportationGroupsList = (
  list: ShippingTransportationGroupsListResponse,
): { label: string; value: string }[] => {
  if (!list) {
    return [];
  }
  return list.map((row) => ({
    label: row.codeDesc,
    value: row.codeId,
  }));
};
